'use client';

// This container is for showing changelogs
import React, { FC, PropsWithChildren, useEffect } from 'react';
import { getLocalStorage, setLocalStorage } from '@/common/localStorages';
import { withNoSSR } from '@/components/NoSSR';
import { useOpenBottomSheet } from './components/BottomSheet';
import useForceUpdate from '@/hooks/forceUpdate';
import { useGetUserStatus } from '@/userStatus/hooks';
import { getAppVersion } from '@/utils/application';
import { checkIsWebView } from '@/utils/device';

const STORAGE_KEY = 'app_version';

const UpdateContainer: FC<PropsWithChildren<{}>> = withNoSSR(({ children }) => {
  const { isVerified } = useGetUserStatus();
  const isWebView: boolean = checkIsWebView();
  const lastVersion: string = getAppVersion() ?? '';
  const userVersion: string | null = getLocalStorage(STORAGE_KEY);

  const shouldShow: boolean =
    !isWebView && isVerified && !!lastVersion && lastVersion !== userVersion;

  const forceUpdate = useForceUpdate();
  const openBottomSheet = useOpenBottomSheet({
    onClose: () => {
      setLocalStorage(STORAGE_KEY, lastVersion as string);
      forceUpdate();
    },
  });

  useEffect(() => {
    if (shouldShow) openBottomSheet();
  }, [shouldShow]);

  return <>{children}</>;
});

export default UpdateContainer;
